import PricingTable from './PricingTable'
import { pricingContainer, pricingSection, PricingHeading } from './Shared'
export default function PlanComparison({ data, plans, billing }) {
    const columns = [
        { label: data.label },
        ...plans.map((plan) => ({
            label: plan.name,
            price: plan.period ? `${plan[billing]}/mo` : plan[billing],
        })),
    ]
    return (
        <section className={pricingSection}>
            <div className={pricingContainer}>
                <PricingHeading {...data} />
                <PricingTable
                    id="plan-comparison"
                    label="Full plan comparison"
                    columns={columns}
                    groups={data.groups}
                />
            </div>
        </section>
    )
}
